<div class="accordions-container">
  <div class="filter">
    <div class="listbox">
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Shop')">
          <span>{{ "ClientApp.FrontOffice.Messaging.GroupMessage.Buy" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Shop'"></i>
        </div>
        <div *ngIf="selected === 'Shop'" class="filterbox content">
          <ssg-select
            name="PurchaseFilterTypeId"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.PurchaseFilter' | translate"
            apiName=""
            textFieldName="Title"
            [dataList]="purchaseFilterTypeList"
            valueFieldName="Id"
            (valueChangeByApiName)="onChanged($event)">
          </ssg-select>
          <date-picker
            id="dpPurchaseStartTime"
            name="PurchaseStartTime"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.PurchaseStartTime' | translate"
            [required]="false"
            textType="date"
            [disabled]="false">
          </date-picker>
          <date-picker
            id="dpPurchaseEndTime"
            name="PurchaseEndTime"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.PurchaseEndTime' | translate"
            [required]="false"
            textType="date"
            [disabled]="false">
          </date-picker>
          <div *ngIf="!PurchaseFilterTypeId || PurchaseFilterTypeId === 1">
            <ssg-input
              name="FromPurchaseAmount"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.FromPurchaseAmount' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </ssg-input>
            <ssg-input
              name="ToPurchaseAmount"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.ToPurchaseAmount' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </ssg-input>
            <ssg-input
              name="FromTotalPurchaseAmount"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.FromTotalPurchaseAmount' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </ssg-input>
            <ssg-input
              name="ToTotalPurchaseAmount"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.ToTotalPurchaseAmount' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </ssg-input>

            <ssg-input
              name="FromPurchaseCount"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.FromPurchaseCount' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </ssg-input>
            <ssg-input
              name="ToPurchaseCount"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.ToPurchaseCount' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </ssg-input>
          </div>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Gender')">
          <span>{{ "ClientApp.FrontOffice.Messaging.GroupMessage.Gender" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Gender'"></i>
        </div>
        <div *ngIf="selected === 'Gender'" class="content">
          <ssg-checkbox-list
            name="GenderIds"
            apiName="Lookup"
            systemName="GNR"
            category="Gender"
            textFieldName="Title"
            valueFieldName="Id"
            [required]="false"
            [disabled]="false"
            (valueChange)="change($event)"
            [group]="formGroup">
          </ssg-checkbox-list>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Location')">
          <span>{{ "ClientApp.FrontOffice.Messaging.GroupMessage.Zone" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Location'"></i>
        </div>
        <div *ngIf="selected === 'Location'" class="content">
          <ssg-checkbox-list
            name="ZoneIds"
            apiName="Zone/ReadLookUp"
            textFieldName="Title"
            valueFieldName="Id"
            [required]="false"
            [disabled]="false"
            (valueChange)="change($event)"
            [group]="formGroup">
          </ssg-checkbox-list>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Customer')">
          <span>{{ "ClientApp.FrontOffice.Messaging.GroupMessage.CustomersCategory" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Customer'"></i>
        </div>
        <div *ngIf="selected === 'Customer'" class="content">
          <ssg-checkbox-list
            name="CustomerCategoryIds"
            apiName="CustomerCategory/ReadLookUp"
            textFieldName="Title"
            valueFieldName="Id"
            [required]="false"
            [disabled]="false"
            (valueChange)="change($event)"
            [group]="formGroup">
          </ssg-checkbox-list>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('NewCustomer')">
          <span>{{ "ClientApp.FrontOffice.Messaging.GroupMessage.RegistrationTime" | translate }}</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'NewCustomer'"></i>
        </div>
        <div *ngIf="selected === 'NewCustomer'" class="content">
          <date-picker
            id="dpRegistrationStartTime"
            name="RegistrationStartTime"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.RegistrationStartTime' | translate"
            [required]="false"
            textType="date"
            [disabled]="false">
          </date-picker>
          <date-picker
            id="dpRegistrationEndTime"
            name="RegistrationEndTime"
            [group]="formGroup"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.RegistrationEndTime' | translate"
            [required]="false"
            textType="date"
            [disabled]="false">
          </date-picker>
        </div>
      </div>
    </div>
  </div>
  <div class="smscontent">
    <div class="smsbox">
      <div class="header">
        <div class="w-100">
          <div class="header">
            <ssg-select
              name="MessageTypeId"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.MessageTemplate' | translate"
              apiName="MessageTemplate"
              textFieldName="Title"
              valueFieldName="Id"
              (valueChange)="change($event)"
              userClass="select-md">
            </ssg-select>
            <div class="info-remain-credit" *ngIf="info">
              <span class="ml-xs color-949494" class="items">{{ "ClientApp.FrontOffice.Messaging.GroupMessage.RemainCredit" | translate }}:</span>
              <span class="price"> {{ info?.RemainCredit | number }} </span>
              <span class="price">&nbsp;{{ "ClientApp.FrontOffice.Messaging.GroupMessage.UnitPrice" | translate }}&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
      <div class="cardbody">
        <template-input
          name="Text"
          [group]="formGroup"
          [(textValue)]="messageInput.Text"
          [items]="groupItems"
          [rows]="6"
          [placeholder]="'ClientApp.FrontOffice.Messaging.GroupMessage.Text' | translate">
        </template-input>
        <div class="row footer">
          <div *ngIf="tryToSendSgain" class="marginleft">
            <time-picker
              name="ExpirationTime"
              [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.ExpirationTime' | translate"
              [group]="formGroup"
              required="false"
              textType="number"
              [disabled]="false">
            </time-picker>
          </div>

          <ssg-button
            icon="icon-paper-plane-o"
            [disabled]="!isValid()"
            class="login-btn btnicon sendbtn"
            (click)="submitForm()"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.GroupSend' | translate"
            appearance="flat">
          </ssg-button>
          <ssg-button
            icon="icon-filter3"
            (click)="ApplayFilter()"
            class="login-btn btnicon filterbtn"
            [label]="'ClientApp.FrontOffice.Messaging.GroupMessage.ApplyFilter' | translate"
            appearance="flat"
            icon="icon-filter_alt-o">
          </ssg-button>
        </div>
      </div>
    </div>
    <div class="smstitle">
      <kgrid
        [label]="label"
        [name]="apiName"
        [columns]="columns"
        [noToolBar]="true"
        [gridViewData]="currentData"
        [isEdit]="false"
        [filtering]="false"
        [unSortableFilterableAll]="true"
        (onDataStateChanged)="onPageChanged($event)"
        [isAdd]="false"
        [isDelete]="false"
        (onRowsSelected)="onRowsSelected($event)"
        [isMulti]="true">
      </kgrid>
    </div>
  </div>
</div>
